module.exports = __webpack_public_path__ + "img/wlp_quiz_night_creation.41b4193b.png";